import { useTranslation } from 'react-i18next';

import type { components } from 'wg-api-sdk';

import Badge from '@/components/common/Badge';

import { getBadgeColor } from '../../utils';

type Props = {
  recommendation: components['schemas']['OnesuranceRecommendation'];
};

export default function RecommendationTitle({ recommendation }: Props) {
  const { t } = useTranslation();

  return (
    <div className="mb-1 flex items-center gap-2 text-sm font-medium">
      {t(`ONESURANCE_RECOMMENDATION_${recommendation.type}_TITLE`)}

      <Badge color={getBadgeColor(recommendation.type, recommendation.level)}>
        {t(`ONESURANCE_RECOMMENDATION_LEVEL_${recommendation.level}`)}
      </Badge>
    </div>
  );
}
